/**
 * SessionBlock — a single session pill in the week grid.
 *
 * Props:
 *   session   {Object}   session resource from API
 *   onClick   {()=>void}
 */

import Badge from '../ui/Badge';
import { SESSION_STATUS_LABELS, SESSION_STATUS_COLORS } from '../../constants/statusLabels';

const SessionBlock = ({ session, onClick }) => {
  const time = session.start_time
    ? session.start_time.slice(0, 5)
    : '';

  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full text-left bg-white border border-gray-200 rounded-lg p-2 mb-1 hover:shadow-sm hover:border-[#17386E]/30 transition-all focus:outline-none focus:ring-2 focus:ring-[#17386E]/30"
      aria-label={`Session ${SESSION_STATUS_LABELS[session.status] ?? session.status} à ${time}`}
    >
      <div className="flex items-center gap-1 mb-1">
        <span className="text-xs font-montserrat text-[#4A4A4A] font-medium">
          {time}
        </span>
      </div>
      {session.subject && (
        <p className="text-xs font-montserrat text-[#4A4A4A] truncate leading-tight mb-1">
          {session.subject.name}
        </p>
      )}
      <Badge
        status={session.status}
        labels={SESSION_STATUS_LABELS}
        colors={SESSION_STATUS_COLORS}
      />
    </button>
  );
};

export default SessionBlock;
